"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var authenticate_public_report_html_1 = __importDefault(require("./authenticate-public-report.html"));
require("./authenticate-public-report.less");
(function (module) {
    var AuthenticatePublicReportController = function ($filter, $scope, $http, $routeParams, $route, $window, initService, env) {
        var $ctrl = this;
        var translate = $filter('translate');
        $scope.$ctrl = $ctrl;
        $ctrl.passcode = '';
        $ctrl.errorMessage = '';
        if (env.get('invalidPasscode')) {
            $ctrl.errorMessage = translate('LOGIN.INVALID_PASSCODE');
        }
        if (env.get('tooManyLoginAttempts')) {
            $ctrl.errorMessage = translate('LOGIN.TOO_MANY_ATTEMPTS');
            $ctrl.tooManyLoginAttempts = true;
        }
        $ctrl.pending = false;
        this.beginPasscodeSubmission = function () {
            $ctrl.errorMessage = '';
            $ctrl.pending = true;
        };
        this.submitForm = function () {
            if (!$ctrl.passcode.length || $ctrl.pending) {
                return;
            }
            $ctrl.beginPasscodeSubmission();
            document.getElementById('form').submit();
        };
    };
    AuthenticatePublicReportController.$inject = [
        '$filter',
        '$scope',
        '$http',
        '$routeParams',
        '$route',
        '$window',
        'prInitService',
        'rsEnvironment'
    ];
    module.component('prAuthenticatePublicReport', {
        templateUrl: authenticate_public_report_html_1.default,
        controller: AuthenticatePublicReportController,
        require: {
            '$bdyCtrl': '^^prBody'
        }
    });
})(angular.module('qualtrics.pr'));
